import axios from 'axios';

// Thin wrappers over the Broadcasts API. Base URL + bearer token are applied
// globally in main.js, so these just hit the relative paths.
export default {
  // Customer-facing: live broadcasts for the caller's own companies.
  getActive() {
    return axios.get('broadcasts/active');
  },

  // Manager/tech: full manage list (active + paused).
  list() {
    return axios.get('broadcasts');
  },

  create(payload) {
    return axios.post('broadcasts', payload);
  },

  update(id, payload) {
    return axios.post(`broadcasts/${id}`, payload);
  },

  toggle(id) {
    return axios.post(`broadcasts/${id}/toggle`);
  },

  end(id) {
    return axios.post(`broadcasts/${id}/end`);
  },

  // Customer "Keep me updated" — adds them as a watcher on the broadcast's ticket.
  watch(id) {
    return axios.post(`broadcasts/${id}/watch`);
  },
};
